import * as React from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { MainState } from "../../Core/reducers";
import { Authorization, GlobalAuthorization } from "../../misc/components/Authorization";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Permission, QueryOrderDirection } from "../../misc/api/apiTypes";
import Condition from "../../misc/components/Condition";
import UserListTable from "./UserListTable";
import { useQueryTable, ClearFiltersAction, QueryTableState, PageAction, SetPageSizeAction } from "../../misc/components/queryTable/Hooks/UseQueryTable";
import { useSecurityContext } from "../../Core/SecurityContext";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

export interface UserListProps {
    currentStudyId?: string;
}

export interface UserListRouteProps {
    didEmailFail?: string;
    isSaveMessageDisplayed?: string;
}

declare var rootUrl: string;

export const UserList = ({ currentStudyId, didEmailFail, isSaveMessageDisplayed }: UserListProps & UserListRouteProps) => {
    const { currentUserPermissions } = useSecurityContext();
    const [loaded, setLoaded] = React.useState(false);
    const [resyncSuccess, setResyncSuccess] = React.useState(null);
    const legacyClient = useWebPortalLegacyClient();
    type RouteParams = UserListRouteProps;

    React.useEffect(() => {
        const getData = async () => {
            const tableParameters = await legacyClient.getTableParameters();

            dispatch(SetPageSizeAction.create(tableParameters.DefaultPageSize));
            setLoaded(true);
        }

        getData();
    }, []);

    const queryTableReducer = useQueryTable({
        query: {
            Page: {
                Current: 1,
                Length: 10,
            },
            Filters: [],
            Members: [],
            Order: {
                Member: 'Email',
                Direction: QueryOrderDirection.Ascending,
            }
        }
    });
    const [_, dispatch] = queryTableReducer;

    const reSyncUsers = async () => {
        setResyncSuccess(false)
        await legacyClient.ReSync()
        setResyncSuccess(true)


        // hack to prevent redirect.
        return false;
    }

    const menuItems = () => {
        const clearFilters = () => {
            dispatch(ClearFiltersAction.create());
        }

        return (
            <div className="ibox-tools">
                <Authorization permissionId={PermissionEnum.AssociateUsersWithSites}
                    studyId={currentStudyId}
                    currentPermissions={currentUserPermissions}
                >
                    <Link to="/users/user-sites" className="btn btn-primary">Associate with Sites</Link>
                </Authorization>
                <GlobalAuthorization permissionId={PermissionEnum.CreateUsers} currentPermissions={currentUserPermissions}>
                    <Link to="/users/create" className="btn btn-primary">Create New</Link>
                </GlobalAuthorization>
                &nbsp;
                <GlobalAuthorization permissionId={PermissionEnum.CreateUsers} currentPermissions={currentUserPermissions}>
                    <div className="btn-group">
                        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Manual Sync <span className="caret"></span>
                        </button>
                        <ul className="dropdown-menu" style={{left: "0px"}}>
                            <li><a href="#" onClick={reSyncUsers}>Power BI</a></li>
                        </ul>
                    </div>
                </GlobalAuthorization>
                &nbsp;
                <button className="btn btn-primary" onClick={clearFilters}>
                    Clear All Filters
                </button>
            </div>
        );
    }

    if (!loaded)
        return <LoadingWithMessage message="Loading Users List" />;

    return (
        <GlobalAuthorization currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.ViewUserManagement, PermissionEnum.ViewUsers, PermissionEnum.CreateUsers, PermissionEnum.EditUsers]}>
            <div className="wrapper wrapper-content">
                {isSaveMessageDisplayed === "true" ?
                    <div className="alert alert-success">
                        <FontAwesomeIcon icon={faCheck} className="icon" /> Saved successfully.
                    </div>
                    : null}
                {didEmailFail === "true" ?
                    <div className="alert alert-warning">
                        <FontAwesomeIcon icon={faExclamationCircle} />The registration email was unable to be sent to the newly created user's email address, there may be an error with the email address. The user has still been saved.
                    </div>
                    : null}
                {resyncSuccess == true ?
                    <div className="alert alert-success">
                        <FontAwesomeIcon icon={faCheck} className="icon" /> Re-Synced successfully.
                    </div>
                    : null}
                <div className="row">
                    <div className="col-md-12">
                        <div className="ibox">
                            <div className="ibox-title">
                                <h2 className="text-primary">Users</h2>
                                {menuItems()}
                            </div>
                            <div className="ibox-content">
                                <div id="usersList">
                                    <UserListTable queryTableReducer={queryTableReducer} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </GlobalAuthorization>
    );
}

function mapStateToProps(state: MainState) {
    return {
        currentStudyId: state.security.studyId,
    }
}

export default connect(mapStateToProps)(UserList);
